import { render, staticRenderFns } from "./SftpUploader.vue?vue&type=template&id=6502d07c"
import script from "./SftpUploader.vue?vue&type=script&lang=js"
export * from "./SftpUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports